export { default as FPSStats } from 'react-fps-stats';
